import React, { useEffect, useState } from "react";

interface SocietyAvatarProps {
  icon?: string | null;
  name: string;
  className?: string;
}

/**
 * Society avatar with a letter-circle fallback. Instagram CDN profile pictures
 * are often blocked on the client even though they load server-side, which
 * renders as a broken empty `<img>`; falling back on the image `error` event
 * keeps the row readable. Instagram-hosted profile photos are treated exactly
 * like a broken image: the Instagram asset is never rendered, only the letter
 * circle is.
 */
const isInstagramAsset = (url: string): boolean =>
  /cdninstagram\.com|instagram\.com/i.test(url);

const SocietyAvatar: React.FC<SocietyAvatarProps> = ({
  icon,
  name,
  className = "",
}) => {
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [icon]);

  if (!icon || broken || isInstagramAsset(icon)) {
    return (
      <span
        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#ffa217] text-xs font-bold text-white ${className}`}
      >
        {name.charAt(0).toUpperCase() || "?"}
      </span>
    );
  }

  return (
    <img
      src={icon}
      alt=""
      onError={() => setBroken(true)}
      className={`h-7 w-7 shrink-0 rounded-full object-cover ${className}`}
    />
  );
};

export default SocietyAvatar;
